export default __webpack_public_path__ + "static/media/logo2.a41a13b2.png";